// Bridge diagnostics. Quiet in production by default, so we don't ship noisy
// console.logs — but the native team can switch them on for a device via:
//   localStorage.setItem("nine_bridge_debug", "1")
// Error paths still use console.warn directly.
export function bridgeLog(...args: unknown[]): void {
  try {
    const enabled =
      import.meta.env?.DEV ||
      localStorage.getItem("nine_bridge_debug") === "1";
    if (enabled) console.log("[bridge]", ...args);
  } catch {
    /* noop */
  }
}
